import React from "react";
import "./footer.scss";
import logo from "../../media/log.jpg";
import {Link} from "react-router-dom";

const footer = () => {
  return (
    <div className="container-footer">
      <div className="container-atas">
        <div className="container-logo">
          <img
            className="gambar-logo"
            src={logo}
            alt="logo-citraland-surabaya"
          />
        </div>
        <div className="container-deskripsi">
          <div className="alamat">
            <h1>Marketing Gallery</h1>
            <h2>Grand Wisata Bekasi</h2>
            <h3>
              Jl. Grand Wisata, Lambangjaya, Kec. Tambun Sel., Kabupaten Bekasi,
              Jawa Barat 17510
            </h3>
            <h4>Contact us : +6281574115424 (Radi)</h4>
            <Link to="/privacy-policy">
              <div className="footer">Privacy Policy</div>
            </Link>
          </div>
          <div className="privasi"></div>
        </div>
      </div>
      <div className="container-bawah">
        © 2024 All Rights Reserved
        <div className="powered">Powered by Linktown</div>
      </div>
    </div>
  );
};

export default footer;
